export enum webHostEnviroment {
  development = "development",
  testing = "testing",
  staging = "staging",
  production = "production",
}
